// Pages that recover a forgotten password: the "forgot" forms and the pages
// the emailed reset links open, for families and organizers.
export const PASSWORD_RECOVERY_PATHS = [
    '/forgot-password',
    '/reset-password',
    '/forgotpwd-org',
    '/reset-pwd-org',
];

export const isPasswordRecoveryPath = (pathname = '') => {
    const path = pathname.replace(/\/+$/, '') || '/';
    return PASSWORD_RECOVERY_PATHS.includes(path);
};

// These pages exist only for signed-out visitors. A browser that still holds a
// login (often an old one the server ended long ago) was shown the 404 page
// instead of the reset form, and nothing on that page cleared the old login,
// so the emailed link failed every time. Opening one of them signs the browser
// out first, as the 401/403 handlers do; a completed reset ends every session
// anyway. Returns true when a stored login was cleared.
export const signOutForPasswordRecovery = (pathname, storage = window.localStorage) => {
    if (!isPasswordRecoveryPath(pathname) || !storage.getItem('accessToken')) return false;
    storage.clear();
    return true;
};
